import {
	updateSingleReservation as updateSingleReservationInStore,
	addReservation as addReservationInStore,
	removeReservation as removeReservationInStore
} from "../actions/store/app-actions";
import { store } from "../store";
import { setSnackbarMessage } from "../actions/store/snackbar-actions";

import {
	Reservation,
	patchReservation,
	addReservations,
	removeReservations
} from "../api/reservations";

export const updateSingleReservation = async (
	id: string,
	updateData: Partial<Reservation>
) => {
	try {
		const res = await patchReservation(id, updateData);
		store.dispatch(updateSingleReservationInStore(res.id, res));
	} catch (e) {
		console.error(e);
		store.dispatch(
			setSnackbarMessage(
				"Aktualisierung der Reservierung fehlgeschlagen!",
				"error"
			)
		);
	}
};

export const addReservation = async (reservation: Reservation) => {
	try {
		const res = await addReservations([reservation]);

		reservation.id = res[0].id;
		store.dispatch(addReservationInStore(reservation));
	} catch (e) {
		console.error(e);
		store.dispatch(
			setSnackbarMessage("Konnte Reservierung nicht hinzufügen!", "error")
		);
	}
};

export const deleteReservation = async (id: string) => {
	try {
		await removeReservations([id]);
		store.dispatch(removeReservationInStore(id));
	} catch (e) {
		console.error(e);
		store.dispatch(
			setSnackbarMessage("Konnte Reservierung nicht löschen!", "error")
		);
	}
};
